import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main resourcesD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-sm-10 mx-auto" }
const _hoisted_12 = { class: "board bg-white" }
const _hoisted_13 = { class: "head-row fcsb flex-md-row" }
const _hoisted_14 = { class: "h2 me-md-3 flex-grow-1 text-primary order-md-0 order-2" }
const _hoisted_15 = { class: "tag btn-primay filled flex-shrink-0 px-4 py-md-0 py-1 mb-md-0 mb-3" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "功能屬性", -1)
const _hoisted_18 = { class: "funds-source-group frcs" }
const _hoisted_19 = { class: "ps-md-2 ps-1" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "創業階段", -1)
const _hoisted_22 = { class: "funds-source-group frcs" }
const _hoisted_23 = { class: "ps-md-2 ps-1" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "資金介紹", -1)
const _hoisted_26 = { class: "pre-text" }
const _hoisted_27 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "網址", -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "所屬單位", -1)
const _hoisted_32 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "聯絡資訊", -1)
const _hoisted_34 = { class: "pre-text" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "frce mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(history.go(-1))",
    class: "btn-anchor back",
    aria: "返回前頁"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "返回前頁")
  ])
], -1)
const _hoisted_36 = {
  key: 1,
  class: "recommend-sec"
}
const _hoisted_37 = { class: "container-lg" }
const _hoisted_38 = { class: "col-sm-10 mx-auto" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3 text-primary" }, "看其他資源", -1)
const _hoisted_40 = {
  class: "d-grid lists-group",
  "grid-column": "2"
}
const _hoisted_41 = { class: "frsb mb-2" }
const _hoisted_42 = { class: "h3 me-5 me-md-3 flex-grow-1" }
const _hoisted_43 = { class: "tag btn-primay active flex-shrink-0 px-4 py-md-0 py-1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "link-anchor"
  }, "詳細內容")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ol", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "首頁",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首頁")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/resources",
                      title: "資源搜尋 - 政府資源總覽",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("資源搜尋 - 政府資源總覽")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.item.name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.item.name), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.item.location?.message), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.types, (type) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: type,
                          class: "funds-source frcs me-md-4 me-2"
                        }, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(type.message) + _toDisplayString(type.name == 'T9' ? '：' + _ctx.item.typeOther  : ''), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.stages, (type) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: type,
                          class: "funds-source frcs me-md-4 me-2"
                        }, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(type.message) + _toDisplayString(type.name == 'S9' ? '：' + _ctx.item.stageOther  : ''), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.item.description), 1)
                  ]),
                  (_ctx.item.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("a", {
                          href: _ctx.item.url,
                          class: "link",
                          title: "另開新視窗",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(_ctx.item.url), 9, _hoisted_29)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("p", null, _toDisplayString(_ctx.item.unit), 1)
                  ]),
                  (_ctx.item.contact)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.item.contact), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_35
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.others.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.others, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "list-card mb-md-3 mb-2"
                  }, [
                    _createVNode(_component_router_link, {
                      to: {name: 'resources-detail', params: { id: item.id }},
                      title: "看其他資源",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(item.location.message), 1)
                        ]),
                        _hoisted_44
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}